var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiBrComet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.659,24c-2.312,0-4.486-.9-6.123-2.536C-4.767,13.742,5.308,3.76,9.476,1.469c.904-.581,2.052-.622,2.996-.107,.829,.453,1.383,1.271,1.504,2.193,2.528-1.812,4.265-2.881,5.377-3.316,1.275-.5,2.672-.208,3.645,.765,.972,.973,1.265,2.369,.765,3.645-.436,1.112-1.504,2.849-3.316,5.377,.922,.121,1.74,.675,2.193,1.504,.516,.944,.474,2.092-.107,2.996-1.43,2.223-6.653,9.476-13.872,9.476ZM11,4.056c-17.441,11.398-2.406,26.355,8.944,8.944h-2.444c-1.199,.039-1.95-1.464-1.2-2.4,2.651-3.535,4.223-5.905,4.669-7.046,.078-.2-.008-.344-.093-.43-.086-.085-.229-.169-.43-.093h0c-1.141,.446-3.511,2.018-7.046,4.669-.455,.34-1.065,.396-1.571,.142-.508-.254-.829-.773-.829-1.342v-2.444Zm-2,13.944c3.957-.1,3.956-5.9,0-6-3.957,.1-3.956,5.9,0,6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiBrComet);
export default __webpack_public_path__ + "static/media/fi-br-comet.f753f7dc6a17e49d65a3050b75306ebb.svg";
export { ForwardRef as ReactComponent };